// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.leo-banner--content[data-v-332a3a6c] {\n  width: calc(100% - 20px);\n}\n.leo-break-word[data-v-332a3a6c] {\n  word-break: break-word;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
